// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"179":"8986dbc6","467":"3dccd80e","625":"6906e23c","655":"f385efa4"}[chunkId] + ".js";
};